<div
    #chartElement
    class="agpr-briefing-chart"
    [style.width]="containerWidth + 'px'"
    [style.height]="containerHeight + 'px'"
></div>
<agpr-twig
    [id]="id + '_twig'"
    class="agpr-briefing-twig"
    [agprLoading]="loading"
    [loadingSmallIndicator]="smallIndicator"
    [twigTemplate]="twigTemplate"
    [data]="twigData"
    [generateOnSend]="generateOnSend"
    (renderedOutput)="setRenderedOutput($event)"
></agpr-twig>
